import React from "react";
import { LazyMotion, domAnimation, m } from "framer-motion";
import ScrollingBanner from "./ScrollingBanner";

const investorLogoFiles = [
  "IDG.svg",
  "northernLight.svg",
  "miracleplus.svg",
  "shunwei.svg",
  "ics&s.svg",
  "lightCloud.svg",
  "xiaomi.svg",
  "cawincapital.svg",
];

const headerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.04 },
  },
};

const headerChild = {
  hidden: { opacity: 0, y: 22 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] as const },
  },
};

export default function InvestorSection() {
  return (
    <section
      id="investors"
      className="relative mx-auto w-full max-w-6xl px-6 py-20 sm:py-28 lg:px-8 lg:py-36"
    >
      <LazyMotion features={domAnimation}>
        <m.div
          className="relative mb-10 flex flex-col items-center text-center sm:mb-12"
          variants={headerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-10% 0px -8% 0px" }}
        >
          <m.h2
            variants={headerChild}
            className="text-foreground text-2xl font-bold tracking-tight sm:text-3xl sm:leading-[1.25] lg:text-[2rem]"
          >
            纽酷科技历史投资方
          </m.h2>
        </m.div>

        <m.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-8% 0px" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <ScrollingBanner shouldPauseOnHover gap="40px">
            {investorLogoFiles.map((filename) => (
              <div
                key={filename}
                className="flex flex-none items-center justify-center text-foreground"
              >
                <img
                  src={`/images/investor_logo/${encodeURIComponent(filename)}`}
                  alt={filename.replace(/\.svg$/i, "")}
                  className="h-9 w-auto max-w-[200px] object-contain opacity-90 grayscale transition-all hover:opacity-100 hover:grayscale-0"
                  loading="lazy"
                />
              </div>
            ))}
          </ScrollingBanner>
        </m.div>
      </LazyMotion>
    </section>
  );
}
